import {
  Booking,
  Recurrence,
  RecurringBooking,
} from "../AppDataProvider/AppDataProvider";
import { FrequencyType, RecurrenceType } from "../GeneratedGraphQL";

export const defaultBooking: Booking = {
  _id: "555456781234567812345221",
  end: "2022-09-16T13:00:00.000Z",
  remainingSpaces: 6,
  start: "2022-09-16T12:30:00.000Z",
};

export const bookingWithPrice: Booking = {
  _id: "555456781234567812345221",
  end: "2022-09-16T13:00:00.000Z",
  price: 3.33,
  remainingSpaces: 1,
  start: "2022-09-16T12:30:00.000Z",
};

export const defaultRecurrence: Recurrence = {
  bookings: [
    {
      _id: "555456781234567812345222",
      end: "2124-01-01T10:00:00.000Z",
      price: null,
      remainingSpaces: 2,
      start: "2124-01-01T09:30:00.000Z",
    },
    {
      _id: "555456781234567812345223",
      end: "2124-01-02T10:00:00.000Z",
      price: 12.5,
      remainingSpaces: 4,
      start: "2124-01-02T09:30:00.000Z",
    },
    {
      _id: "555456781234567812345224",
      end: "2124-01-03T10:00:00.000Z",
      price: 12.5,
      remainingSpaces: 6,
      start: "2124-01-03T09:30:00.000Z",
    },
  ],
  endDate: null,
  frequency: 1,
  frequencyType: FrequencyType.Daily,
  id: "123456789",
  occurrences: 3,
  recurrenceType: RecurrenceType.IndividualBookings,
};

export const defaultRecurringBooking: RecurringBooking = {
  _id: "555456781234567812345222",
  end: "2124-01-01T10:00:00.000Z",
  recurring: defaultRecurrence,
  remainingSpaces: 13,
  start: "2124-01-01T09:30:00.000Z",
};

export const noPriceRecurrence: Recurrence = {
  bookings: [
    {
      _id: "555456781234567812345226",
      end: "2124-01-01T15:00:00.000Z",
      price: null,
      remainingSpaces: 13,
      start: "2124-01-01T14:30:00.000Z",
    },
    {
      _id: "555456781234567812345227",
      end: "2124-01-02T15:00:00.000Z",
      price: null,
      remainingSpaces: 13,
      start: "2124-01-02T14:30:00.000Z",
    },
  ],
  endDate: null,
  frequency: 1,
  frequencyType: FrequencyType.Daily,
  id: "123456789",
  occurrences: 2,
  recurrenceType: RecurrenceType.AllBookings,
};

export const noPriceRecurringBooking: RecurringBooking = {
  _id: "555456781234567812345222",
  end: "2124-01-01T10:00:00.000Z",
  recurring: noPriceRecurrence,
  remainingSpaces: 4,
  start: "2124-01-01T09:30:00.000Z",
};

export const recurringBookingNoPrice: Booking = {
  _id: "555456781234567812345225",
  end: "2124-01-01T15:00:00.000Z",
  recurring: noPriceRecurrence,
  remainingSpaces: 4,
  start: "2124-01-01T14:30:00.000Z",
};
